<template>
    <div v-if="ageMin || ageMax" class="has-text-weight-bold" :title="translate('page.category_manager.age_limit')">
        <span class="icon">
            <i class="far fa-calendar-alt" />
        </span>
        <span v-if="ageMin">
            {{ ageMin }}
        </span>
        <span v-else class="icon">
            <i class="fa fa-infinity" />
        </span>
        -
        <span v-if="ageMax">
            {{ ageMax }}
        </span>
        <span v-else class="icon">
            <i class="fa fa-infinity" />
        </span>
    </div>
</template>

<script setup lang="ts">
    import { translate } from "../Common/translations";

    defineProps<{
        ageMin: number | null;
        ageMax: number | null;
    }>();
</script>

<style scoped></style>
